export const formatMultipleCheckboxData = (selected, options) => {
  const filtered_options = options?.filter(
    ({ value: valOptions }) =>
      !selected.some(({ value: valSelected }) => valSelected === valOptions) // es6 function that filters array of objects that exists in both arrays
  )
  return [...selected, ...filtered_options]
}
